var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3144 8.00299L4.24036 13.7105C4.08012 13.861 4.00207 14.0383 4.00621 14.2423C4.01035 14.4463 4.09254 14.6236 4.25277 14.7742C4.413 14.9247 4.60166 15 4.81876 15C5.03586 15 5.22452 14.9247 5.38474 14.7742L11.5705 8.97341C11.7162 8.83644 11.8243 8.68297 11.8946 8.51298C11.9649 8.34297 12 8.17298 12 8.00299C12 7.833 11.9649 7.66301 11.8946 7.493C11.8243 7.32302 11.7162 7.16954 11.5705 7.03257L5.38474 1.22018C5.22452 1.06961 5.03379 0.996269 4.81255 1.00015C4.59132 1.00404 4.40059 1.08126 4.24036 1.23183C4.08012 1.3824 4 1.55967 4 1.76366C4 1.96765 4.08012 2.14494 4.24036 2.2955L10.3144 8.00299Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.b76b5c94bc7baf06f9a2e97f5ed4eccb.svg";
export { ForwardRef as ReactComponent };